import React from 'react';
import {UserContext} from '../../utils/usercontext';
import {postApi, putApi, deleteApi} from '../../utils/functions';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../components/fontawesome/fontawesome';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';


class StripeCards extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
      status: false,
      cards: [],
      payment: false,
      result: false,
    };
    this.getCards = this.getCards.bind(this);
    this.makePayment = this.makePayment.bind(this);
    this.defaultPayment = this.defaultPayment.bind(this);
    this.removePayment = this.removePayment.bind(this);
  }

  async componentDidMount() {
    this.getCards();
  }

  async getCards() {
    let params = new URLSearchParams();
		const x = await postApi('/v3/payment/stripe/cards', params);
    this.setState({status: true, cards: x.data?x.data:[]});
  }

  async makePayment(method, payment) {
    this.setState({payment: true}, async ()=>{
      let result = await this.props.payment(method, payment);
      this.setState({payment: false, result});
    });
  }

  async defaultPayment(payment) {
    this.setState({payment: true}, async ()=>{
      let params = new URLSearchParams();
      params.append('payment', payment);
      await putApi('/v3/payment/stripe/defaultcard', params);
      await this.getCards();
      this.setState({payment: false});
    });
  }

  async removePayment(payment) {
    if( window.confirm("Are you sure you wish to remove this payment method?") ) {
      this.setState({payment: true}, async ()=>{
        let params = new URLSearchParams();
        params.append('payment', payment);
        await deleteApi('/v3/payment/stripe/removecard', params);
        await this.getCards();
        this.setState({payment: false});
      });
    }
  }

  render() {
    const stripeCards = this.state.cards.map((e,i) => {
			let cardbrand = 0;
			switch(e.brand) {
				case 'visa': cardbrand = 1; break;
				case 'mastercard': cardbrand = 2; break;
        case 'diners': cardbrand = 10; break;
        case 'discover': cardbrand = 14; break;
        case 'amex': cardbrand = 22; break;
				default: cardbrand = 0; break;
			}
			let months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      
      return (
        <Row key={i} className="gx-0 mb-3">
					<Col xs={12} md={6} style={{display: 'flex'}}>
						{cardbrand > 0 &&
							<div style={{float: 'left'}}>
								<img src={`https://cloud1.ultrastream.io/images/cards/${cardbrand}.png`} width="48" height="32" alt="Card brand" />
							</div>
						}
						<Form.Control
							type="text"
							value={`${e.brand} last four: *** ${e.last4} ${e.default===true?'(Default)':''}`}
							disabled={true}
							style={{opacity: 0.9}}
						/>
					</Col>
					<Col xs={12} md={3}>
						<Form.Control
							type="text"
							value={`Expires ${months[e.exp_month-1]} ${e.exp_year}`}
							disabled={true}
							style={{opacity: 0.9}}
						/>
					</Col>
					<Col xs={12} md={3}>
            {this.props.order ?
              <>
                <Button size="sm" disabled={this.state.payment} onClick={()=>this.makePayment('stripe', e.id)}>Pay</Button>
                {this.state.result?.status!==200 && this.state.result?.card === e.id &&
                  <span className="badge bg-danger-transparent text-danger fs-14">&nbsp;&nbsp;{this.state.result.error}!</span>
                }
              </>
            :
              <ButtonGroup>
                <OverlayTrigger placement="top" key="overlay-1" overlay={<Tooltip id="tooltip1">Remove this payment method.</Tooltip>}>
                  <Button size="sm" variant={'danger'} onClick={()=>this.removePayment(e.id)} disabled={this.state.payment}>
                    <FontAwesomeIcon icon="trash" />
                  </Button>
                </OverlayTrigger>
                {this.state.cards.length > 1&&
                  <>
                    {e.default===false &&
                      <OverlayTrigger placement="top" key="overlay-1" overlay={<Tooltip id="tooltip1">Set as default payment method.</Tooltip>}>
                        <Button size="sm" variant={'info'} onClick={()=>this.defaultPayment(e.id)} disabled={this.state.payment}>
                          <FontAwesomeIcon icon="check" />
                        </Button>
                      </OverlayTrigger>
                    }
                  </>
                }
              </ButtonGroup>
            }
					</Col>
				</Row>
			)
		});

    return (
      <>
        {stripeCards}
      </>
    )
  }
}

export default StripeCards;